import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Editcollab from "./components/Assignments/editcollab";
import Signup from "../src/components/HomePage/Signup";
import Signin from "../src/components/HomePage/signin";
import Home from "./components/HomePage";
import Postlogin from "./components/PostloginHome";
import Land from "./components/HomePage";
import OTP from "./components/HomePage/OTP";
// import { auth } from "./components/firebase.config
import Createassignment from "./components/Assignments/Createassignment";
import Pastcollabs from "./components/Assignments/Pastcollabs";
import Futurecollabs from "./components/Assignments/futurecollabs";
import Navbar from "../src/components/HomePage/Nav";
import Footer from "../src/components/HomePage/Footer";
import Footerformobile from "../src/components/HomePage/footerformobile";
import { driverSelector } from "./api/driver";
import { useSelector } from "react-redux";
import Profile from "../src/components/Profile";
import Collabs from "../src/components/Pages/Collabs";
import Tireanimation from "../src/components/Pages/Gsapexample";
import AllRoutes from "../src/components/Routes";
import Indepthroute from "../src/components/Routes/route-traking";
import Payments from "../src/components/Payments";
import RouteDetails from "../src/components/Bookings/Bookingdetails";
import Documents from "../src/components/Profile/documentsmain";
import SigninWithPassword from "../src/components/HomePage/signinvithpswd";
import Performance from "../src/components/Performance";
import DriverIDCard from "./components/DriverIdCard/DriverIdCard";
import DriverDocuments from "./components/DriverDocuments/DriverDocuments";
import MyUPI from "./components/Profile/myUpi";
import Aboutus from "../src/components/HomePage/aboutus";
import Contactus from "../src/components/HomePage/contactus";
import EditDriver from "./components/EditDriver/EditDriver";
function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
   const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

   useEffect(() => {
    if (isMobile) return; // skip scroll logic on mobile

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 200) {
        // before threshold → show navbar
        setShowNavbar(true);
      } else {
        if (currentScrollY > lastScrollY) {
          // scrolling down → hide
          setShowNavbar(false);
        } else {
          // scrolling up → show
          setShowNavbar(true);
        }
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, isMobile]);

  const { driverAuthenticate } = useSelector(driverSelector);
  console.log("<<<-->>>>", driverAuthenticate);
  return (
    <>
      <div style={{ fontFamily: "Nunito Sans" }}>
         <div
        style={{
          position: isMobile ? "fixed" : showNavbar ? "fixed" : "absolute",
          top: isMobile ? 0 : showNavbar ? 0 : "-80px", // adjust navbar height
          left: 0,
          right: 0,
          zIndex: 1000,
          transition: "top 0.3s ease",
        }}
      >
        <Navbar />
      </div>
        <Routes>
          <Route
            path="/"
            element={driverAuthenticate ? <Postlogin /> : <Home />}
          />

          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/home" element={<Home />} />
          <Route path="/postloginhome" element={<Postlogin />} />
          <Route path="/signin/authopage/:pno" element={<OTP />} />
          <Route path="/createassignment" element={<Createassignment />} />
          <Route path="/pastcollabs" element={<Pastcollabs />} />
          <Route path="/futurecollabs" element={<Futurecollabs />} />
          <Route path="/edit-collab/:id" element={<Editcollab />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/collabs" element={<Collabs />} />
          <Route path="/gsapex" element={<Tireanimation />} />
          <Route path="/routes" element={<AllRoutes />} />
          <Route path="/routeindepth/:routeid" element={<Indepthroute />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/ridedetails/:rideid" element={<RouteDetails />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/signpswd" element={<SigninWithPassword />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/IDCard" element={<DriverIDCard />} />
          <Route path="/driverDocuments" element={<DriverDocuments />} />
          <Route path="/myUPI" element={<MyUPI />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/edit-driver/:id" element={<EditDriver />} />
        </Routes>
        <div>
          {isMobile && driverAuthenticate ? <Footerformobile /> : <Footer />}
        </div>
      </div>
    </>
  );
}

export default App;
